// Policy-change notice: privacy.tgmpanel.com publishes /policy-notice.json
// ({ version: "YYYY-MM-DD", texts: { <lang>: { dir, url, title, text, link, dismiss } } }),
// and the member sees a banner until they dismiss that version on this device.

export const DISMISSED_KEY = 'policy_notice_dismissed';

const VERSION = /^\d{4}-\d{2}-\d{2}$/;

// A path on the privacy site ("/pl/privacy-policy"), never "//host" or "@host", which would turn
// the link into another site; no backslash, which browsers read as a slash.
const SITE_PATH = /^\/(?![/\\])[^@\s\\]*$/;

const isString = value => typeof value === 'string' && value !== '';

// An entry with a missing field would render an empty box with a link to nowhere.
const isUsable = text => !!text && SITE_PATH.test(text.url || '')
  && ['title', 'text', 'link', 'dismiss'].every(key => isString(text[key]));

// The privacy site serves base codes (pl, es) plus zh-tw; the portal may hold a regional
// variant (es-MX, pt-BR, zh-TW) or none at all.
export function pickNoticeText(notice, language) {
  const texts = (notice && notice.texts) || {};
  const code = String(language || '').trim().toLowerCase().replace(/_/g, '-');
  const own = key => (Object.prototype.hasOwnProperty.call(texts, key) ? texts[key] : null);
  return [code, code.split('-')[0], 'en'].map(own).find(isUsable) || null;
}

// A malformed version in the file never shows the banner: a broken file must not nag every member
// on every visit. Garbage in storage counts as never dismissed. Any other version than the
// dismissed one shows, so a mistyped future date that was dismissed cannot hide later notices.
export function isNoticeDue(notice, dismissedVersion) {
  const version = notice && notice.version;
  if (!VERSION.test(version || '')) return false;
  return version !== dismissedVersion;
}

// Dismissals are kept per member ({ "<rmsid>": "<version>" }): on a shared browser, one member
// dismissing must not hide the notice from the next one. localStorage can throw (private mode,
// blocked storage); the banner then shows once per visit.
const readAll = () => {
  try {
    const all = JSON.parse(window.localStorage.getItem(DISMISSED_KEY));
    return all && typeof all === 'object' && !Array.isArray(all) ? all : {};
  } catch {
    return {};
  }
};

export function readDismissed(member) {
  const all = readAll();
  return Object.prototype.hasOwnProperty.call(all, String(member)) ? all[String(member)] : null;
}

export function writeDismissed(member, version) {
  try {
    window.localStorage.setItem(DISMISSED_KEY, JSON.stringify({ ...readAll(), [String(member)]: version }));
  } catch {
    // nothing to keep it in; dismissing still hides it for this visit
  }
}
